var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageedit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15011",
    "data-name": "Group 15011",
    transform: "translate(-1321 -354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15010",
    "data-name": "Group 15010",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_726",
    "data-name": "Ellipse 726",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1325 355)",
    fill: " var(--secondaryColor)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,12.413V14.5H6.583l6.144-6.144L10.644,6.27Zm9.838-5.671a.553.553,0,0,0,0-.783l-1.3-1.3a.553.553,0,0,0-.783,0L11.238,5.675l2.083,2.083,1.017-1.017Z",
    transform: "translate(1321.5 354.504)",
    fill: "var(--bgColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageedit);
export default __webpack_public_path__ + "static/media/imageedit.7cc1b73b3e0a669c87ddf9d2ec3c3ede.svg";
export { ForwardRef as ReactComponent };